import { useState, useCallback } from 'react';
import { gamesApi, type RouletteBetType } from '../api/games';
import { useWalletStore } from '../store/walletStore';
import { ApiError } from '../api/functionsClient';
import type { RouletteResult } from '../types';

export function useRoulette() {
  const [spinning, setSpinning] = useState(false);
  const [result, setResult] = useState<RouletteResult | null>(null);
  const [error, setError] = useState<string | null>(null);
  const setBalance = useWalletStore((s) => s.setBalance);

  const placeBet = useCallback(
    async (betAmount: number, betType: RouletteBetType, betValue?: number) => {
      setSpinning(true);
      setError(null);
      try {
        const res = await gamesApi.playRoulette(betAmount, betType, betValue);
        setResult(res);
        setBalance(res.balanceAfter);
        return res;
      } catch (err) {
        setError(err instanceof ApiError ? err.message : 'Bet failed');
        throw err;
      } finally {
        setSpinning(false);
      }
    },
    [setBalance],
  );

  return { placeBet, spinning, result, error };
}
